import React, { useState, useEffect } from "react";
import { Box, Button, Dropdown, DropdownItem, Icons, Tooltip } from "fds";
import "../index.scss";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import useMeetingStore from "../../../redux/dispatcher/useMeetingStore";
import { meetingDTO } from "../../../types/meeting";
import MeetingBottom from "../../../components/MeetingBottom";
import utilsCommon from "../../../shared/utils/common";
import { t } from "i18next";

dayjs.extend(utc);

const ClientMeeting = ({
  workgroupId,
  refreshCnt,
}: {
  workgroupId: string;
  refreshCnt: number;
}) => {
  const sort_by = [
    { resource: t("meeting.planning"), key: "future" },
    { resource: t("meeting.finish"), key: "past" },
  ];
  const { meetingState, getmeetingList } = useMeetingStore();
  const [buttonClick, setButtonClick] = useState(0);
  const [meetingList, changeMeetingList] = useState<meetingDTO[]>([]);

  const [filter, changeFilter] = useState({
    pageNo: 1,
    resultSize: 20,
    startTime: dayjs().utc().format("YYYY-MM-DDTHH:mm:ss[Z]"),
    timeDirection: "future",
  });
  useEffect(() => {
    getmeetingList({ workgroupId: workgroupId, zoomDto: filter });
  }, [filter, refreshCnt]);
  useEffect(() => {
    changeFilter({
      pageNo: 1,
      resultSize: 20,
      startTime: dayjs().utc().format("YYYY-MM-DDTHH:mm:ss[Z]"),
      timeDirection: "future",
    });
  }, [workgroupId]);
  useEffect(() => {
    changeMeetingList(meetingState.meetingList);
  }, [meetingState.meetingList]);

  /** 웹으로 이동 후, 화상 회의 예약 */
  const handleMoveWebToCreateMeeting = () => {
    if (utilsCommon.isClientLogin("MAC")) {
      (window as any)?.webkit?.messageHandlers.goWebMakingMeeting.postMessage(
        workgroupId
      );
    } else {
      if (window?.chrome?.webview && window?.chrome?.webview?.hostObjects) {
        window?.chrome?.webview?.hostObjects.client.goWebMakingMeeting(
          workgroupId
        );
      }
    }
  };
  const changeFilterByKey = (key: string, value: any) => {
    changeFilter({ ...filter, [key]: value });
  };
  return (
    <Box classes="clientMeeting clientWorkgroupBody">
      <Box classes="clientWorkgroupBody-header">
        <Dropdown
          btnStyle="link"
          placeholder="asdf"
          buttonClick={buttonClick}
          value={
            sort_by.filter((item) => item.key === filter.timeDirection)[0]
              .resource
          }
          classes="mg mr-auto"
        >
          {sort_by.map((item) => (
            <DropdownItem
              label={item.resource}
              type="check"
              checked={item.key === filter.timeDirection}
              checkColor={item.key === filter.timeDirection}
              onClick={() => {
                document.getElementById("docTable")?.scrollTo(0, 0);
                changeFilter({ ...filter, timeDirection: item.key, pageNo: 1 });
                setButtonClick(buttonClick + 1);
              }}
            />
          ))}
        </Dropdown>
        <Tooltip message={t("meeting.schedule")} classes="mg mr-8">
          <Button
            leadingIcon={<Icons variant="line" label="calendar" />}
            btnStyle="icon"
            onClick={handleMoveWebToCreateMeeting}
          />
        </Tooltip>
      </Box>
      <MeetingBottom
        meetingList={meetingList}
        handleCreateMeeting={handleMoveWebToCreateMeeting}
        filter={filter}
        changeFilterByKey={changeFilterByKey}
        isInitFilter={filter.timeDirection === "future"}
        tableHeight="433px"
        page="client"
      />
    </Box>
  );
};

export default ClientMeeting;
